import React, { useContext, useState } from "react";
import cross from "../Images/cross.png";
import call from "../Images/call.png";
import "./dial.css";
import { Link, useNavigate } from "react-router-dom";
import UserCreateContext from "../Context/context";
import { useRef } from "react";

const Dial = () => {
  const inpref = useRef();
  const navigate = useNavigate();
  const userContext = useContext(UserCreateContext);
  const [showerror, setShowerror] = useState(false);
  const [showcall, setShowcall] = useState(false);
  const [input, setInput] = useState("");

  const userData = userContext.userData;
  const handleSubmit = (event) => {
    let inp = input;
    if (inp.length < 20) {
      setInput((inp += event.target.value));
    }
    inpref.current.focus();
  };
  const handleCross = () => {
    const str = input.substring(0, input.length - 1);
    setInput(str);
    inpref.current.focus();
  };
  const handleInput = (event) => {
    console.log("inp : ", input);
    setInput(event.target.value);
    console.log("inp : ", input);
    inpref.current.focus();
  };

  const errorMessage = () => {
    console.log("in error");

    console.log(showerror);
    const checkerror = showerror;
    return (
      <div
        className="error"
        style={{
          display: checkerror ? "" : "none",
        }}
      >
        <h4>Please enter Correct Phone number</h4>
      </div>
    );
  };
  const callMessage = () => {
    console.log("in call");

    console.log(showcall);

    return (
      <div
        className="calling"
        style={{
          display: showcall ? "" : "none",
        }}
      >
        <h4>Calling....</h4>
      </div>
    );
  };
  const handleCall = () => {
    const inp = input;
    console.log(inp.length);
    console.log(inp);
    if (inp.length < 10) {
      console.log("Error inf ");
      setShowerror(true);
      setShowcall(false);
      errorMessage();
    } else {
      console.log("called");
      setShowcall(true);
      setShowerror(false);
      callMessage();

      setTimeout(() => {
        console.log("INNAV");
        navigate("/call");
      }, 3000);
    }
    inpref.current.focus();
  };

  const handleKeypress = (e) => {
    if (e.keyCode === 13) {
      handleCall();
    }
  };

  return (
    <div className="dialpad">
      <div className="messages">
        {errorMessage()}
        {callMessage()}
      </div>
      <div className="container1">
        <div>
          <h1 className="dialtxt">Dial Pad</h1>
          <div className="userdata">
            <div className="usertxt">User : {userData.name}</div>
            <div className="usertxt">
              <Link to="/login">Log out</Link>
            </div>
          </div>
        </div>
        <div className="container2">
          <input
            type="tel"
            placeholder="Enter number to dial"
            className="input"
            onChange={handleInput}
            value={input}
            maxLength={20}
            autoFocus
            ref={inpref}
            onKeyDownCapture={handleKeypress}
          />

          <div className="butt" onClick={handleCross}>
            <img src={cross} alt="" />
          </div>
        </div>
        <div className="container3">
          <div className="pad">
            <button type="button" onClick={handleSubmit} value="1">
              1
            </button>
            <button type="button" onClick={handleSubmit} value="2">
              2
            </button>
            <button type="button" onClick={handleSubmit} value="3">
              3
            </button>
          </div>
          <div className="pad">
            <button type="button" onClick={handleSubmit} value="4">
              4
            </button>
            <button type="button" onClick={handleSubmit} value="5">
              5
            </button>
            <button type="button" onClick={handleSubmit} value="6">
              6
            </button>
          </div>
          <div className="pad">
            <button type="button" onClick={handleSubmit} value="7">
              7
            </button>
            <button type="button" onClick={handleSubmit} value="8">
              8
            </button>
            <button type="button" onClick={handleSubmit} value="9">
              9
            </button>
          </div>
          <div className="pad">
            <button type="button" onClick={handleSubmit} value="*">
              *
            </button>
            <button type="button" onClick={handleSubmit} value="0">
              0
            </button>
            <button type="button" onClick={handleSubmit} value="#">
              #
            </button>
          </div>
        </div>
        <div className="dial">
          <button className="dial2" onClick={handleCall}>
            <img src={call} alt="" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Dial;
